import { VehicleImageWithMeta } from '../../types/vehicle';

export function createImageUrl(cdnUrl: string, image: VehicleImageWithMeta) {
  const format =
    image.available_format?.find((f) => f === '.webp') ??
    image.available_format?.[0] ??
    '.webp'; // Fallback to webp if no format is available, however assembleInteriorExteriorImageBuckets should ensure this is never the case

  return `${cdnUrl}/${image.path}${format}`;
}
